import { channelConstants, sortFormMonths } from "./dashboard.constants";
export function formattedDate(inputDate) {
    const date = new Date(inputDate);
    // Extract date components
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");
    // Formatted date string
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
}
export const getTimeZoneInHours = () => {
    const timezoneOffset = new Date().getTimezoneOffset();
    const offset = Math.abs(timezoneOffset);
    //%2B - '+', because these are sent in query params in API URL
    const offsetOperator = timezoneOffset < 0 ? "%2B" : "-";
    const offsetHours = Math.floor(offset / 60)
        .toString()
        .padStart(2, "0");
    const offsetMinutes = Math.floor(offset % 60)
        .toString()
        .padStart(2, "0");
    return `${offsetOperator}${offsetHours}:${offsetMinutes}`;
};
export const isWAChannel = (ch) => ch === channelConstants.WHATSAPP;
export const isSmsChannel = (ch) => ch === channelConstants.SMS;
export const isEmailChannel = (ch) => ch === channelConstants.EMAIL;
export const isAllChannel = (ch) => ch === channelConstants.ALL_CHANNEL;
export const isVoiceChannel = (ch) => ch === channelConstants.VOICE;
export const isRCSChannel = (ch) => ch === channelConstants.RCS;
export const isVRChannel = (ch) => ch === channelConstants.VIRTUAL_RECEPTIONIST;
export const isNetworkChannel = (ch) => ch === channelConstants.NETWORK;
/**
 * Filters the list of month names to include only those within the start and end dates,
 * handling year-end wrapping (e.g., Oct -> Feb).
 *
 * @param {string} startDate - The start date string (e.g., "2025-10-10T...").
 * @param {string} endDate - The end date string (e.g., "2026-02-10T...").
 * @returns {string[]} An array of month names within the inclusive range.
 */
export function getMonthsBySelectedDates(startDate, endDate) {
    // Date.getMonth() returns 0 for Jan, 11 for Dec. This matches the array index (i).
    const startMonthIndex = new Date(startDate).getMonth();
    const endMonthIndex = new Date(endDate).getMonth();
    if (startMonthIndex <= endMonthIndex) {
        // Case 1: Range is within the same year (e.g., April to September)
        return sortFormMonths.filter((_, i) => i >= startMonthIndex && i <= endMonthIndex);
    }
    else {
        // Case 2: Range wraps around the year end (e.g., October to February)
        // This includes all months from the start month up to December (i >= startMonthIndex)
        // AND all months from January up to the end month (i <= endMonthIndex)
        return sortFormMonths.filter((_, i) => i >= startMonthIndex || i <= endMonthIndex);
    }
}
